module.exports = __webpack_public_path__ + "img/signup-guide-04-03.c5f73131.png";